import { IPermissionsContext } from "../../ipermissions-context/ipermissions-context.interface";
import { IPermissions } from "../../ipermissions/ipermissions.interface";
import { hasUserGroup } from "../../ipermissions-context/ipermissions-context.functions";
import { UserGroup } from "../../../../../constants/types";
import { IPermissionPolicyEvaluator } from "../../ipermissions/ipermission-policy.type";

export const inventoryReviewerGroupPolicy = (next?: IPermissionPolicyEvaluator) => (
  context: IPermissionsContext,
  permissions: IPermissions
) => {
  // console.log("checkInventoryReviewerPolicy -->");
  if (hasUserGroup(context, UserGroup.INVENTORY_REVIEWERS)) {
    // console.log("checkInventoryReviewerPolicy --> TRUE");
    // There are no FE specific access add-ons in the matrix
  }

  if (next) {
    return next(context, permissions);
  }
};
